import * as React from 'react'

import { css, Global, useTheme } from '@emotion/react'
import convert from 'color-convert'

import colors, { Colors } from '../theme/colors'
import { dropShadows } from '../theme/dropShadows'
import maxWidths from '../theme/maxWidths'
import { pxToRem, typographyDefaults } from '../theme/typography'
import weights from '../theme/weights'

export default () => {
  const theme = useTheme()
  return (
    <Global
      styles={css`
        :root {
          ${Object.keys(colors).map(key => {
            const color = key as Colors
            return `--mooncake-color-${key}: ${theme.colors[color]}; --mooncake-color-${key}-rgb: ${convert.hex.rgb(
              theme.colors[color]
            )}`
          })}
          ${Object.keys(dropShadows).map(key => {
            const value = key as keyof typeof dropShadows
            return `--mooncake-dropShadow-${key}: ${theme.dropShadows[value]};`
          })}
          ${Object.keys(maxWidths).map(key => {
            const maxWidth = key as keyof typeof maxWidths
            return `--mooncake-maxWidth-${key}: ${theme.maxWidths[maxWidth]};`
          })}
          ${Object.keys(weights).map(key => {
            const weight = key as keyof typeof weights
            return `--mooncake-weights-${key}: ${theme.weights[weight]};`
          })}
          ${Object.keys(typographyDefaults).map(key => {
            const fontStyles = key as keyof typeof typographyDefaults
            const fontSize = `--mooncake-typography-${key}-fontSize: ${pxToRem(
              typographyDefaults[fontStyles].fontSize
            )};`
            const lineHeight = `--mooncake-typography-${key}-lineHeight: ${typographyDefaults[fontStyles].lineHeight};`
            const weight = `--mooncake-typography-${key}-weight: ${typographyDefaults[fontStyles].weight};`

            return [fontSize, lineHeight, weight].join(' ')
          })}
        }
      `}
    />
  )
}
